import { render, staticRenderFns } from "./UserEditInsurance.vue?vue&type=template&id=626d34be&"
import script from "./UserEditInsurance.vue?vue&type=script&lang=js&"
export * from "./UserEditInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports